// TODO to be removed after 100% prepaid rollout
import { useIntl } from "react-intl";
import { t } from "translations";

import { track } from "apps-common/utils/analytics";

import { routes } from "../routes";

import { NavigationRow, SectionCard } from "./SectionCard";

export const MembershipPlan = () => {
  const intl = useIntl();
  return (
    <SectionCard title={t("membership_hub_product_page_title")}>
      <NavigationRow
        label={intl.formatMessage({
          id: "membership_hub_update_membership_plan_link",
        })}
        href={routes.updatePlan}
        onClick={() => {
          track({
            event: "Link Clicked",
            payload: {
              cta: "update_plan",
              location: "body",
            },
          });
        }}
      />
    </SectionCard>
  );
};
